import { render, staticRenderFns } from "./SchedulesTabs.vue?vue&type=template&id=0536e1c6&"
import script from "./SchedulesTabs.vue?vue&type=script&lang=js&"
export * from "./SchedulesTabs.vue?vue&type=script&lang=js&"
import style0 from "./SchedulesTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3001884671/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0536e1c6')) {
      api.createRecord('0536e1c6', component.options)
    } else {
      api.reload('0536e1c6', component.options)
    }
    module.hot.accept("./SchedulesTabs.vue?vue&type=template&id=0536e1c6&", function () {
      api.rerender('0536e1c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/containers/customer/devices/schedules/SchedulesTabs.vue"
export default component.exports